export default "__VITE_ASSET__zjDRexTw__"